import { ActionDataFieldResource } from "./dataField";
import { RuleSetBlockOptionResource } from "./ruleSet";
import { RegistrationFormSectionResource } from "./section";
import { RegistrationFormStepResource } from "./step";

export enum ActionTypes {
	SHOW_DATA_FIELD = "showDataField",
	SHOW_SECTION = "showSection",
	SHOW_STEP = "showStep",
	SHOW_BLOCK = "showBlock",
}

interface BaseAction {
	id: number;
}

export interface ActionResourceTypeShowDataField extends BaseAction {
	type: ActionTypes.SHOW_DATA_FIELD;
	value: {
		dataField: ActionDataFieldResource;
		section: RegistrationFormSectionResource;
	};
}

export interface ActionResourceTypeShowSection extends BaseAction {
	type: ActionTypes.SHOW_SECTION;
	value: RegistrationFormSectionResource;
}

export interface ActionResourceTypeShowStep extends BaseAction {
	type: ActionTypes.SHOW_STEP;
	value: RegistrationFormStepResource;
}

export interface ActionResourceTypeShowBlock extends BaseAction {
	type: ActionTypes.SHOW_BLOCK;
	value: RuleSetBlockOptionResource;
}

export type ActionResource =
	| ActionResourceTypeShowDataField
	| ActionResourceTypeShowSection
	| ActionResourceTypeShowStep
	| ActionResourceTypeShowBlock;
